import { CoordinateZero, VerticalType, Editor, ContainerType, Platform, EventArea } from '@tencent/alloy-editor';
import { Container, StrokeStyle, Color, SvgGraphics, ColorFill, ImageFill, Fill, FontStyle, Point, Text, PointerEvents, Matrix } from '@tencent/alloy-renderer';
import { imageCache, generateEffectFilters, FillMode, setFillStyle, Stroke } from '@tencent/alloy-renderer-adapter';

function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}

function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}

function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}

function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}

function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}

var TextDirectionType;
(function (TextDirectionType) {
  TextDirectionType["HORIZONTAL"] = "horz";
  TextDirectionType["VERTICAL"] = "eaVert";
  TextDirectionType["ROTATE_90"] = "vert";
  TextDirectionType["ROTATE_270"] = "vert270";
  TextDirectionType["WORD_ART_VERTICAL_RTL"] = "wordArtVertRtl";
  TextDirectionType["WORD_ART_VERTICAL_LTR"] = "wordArtVert";
})(TextDirectionType || (TextDirectionType = {}));

function _callSuper$2(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$2() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$2() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$2 = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet$2(t, e, o, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), e, o); return 2 & r && "function" == typeof p ? function (t) { return p.apply(o, t); } : p; }
/**
 * 文本下划线容器，用于绘制同一行文字的下划线，保证对齐
 */
var TextUnderlineContainer = /*#__PURE__*/function (_Container) {
  function TextUnderlineContainer(id, textDirection) {
    var _this;
    _classCallCheck(this, TextUnderlineContainer);
    _this = _callSuper$2(this, TextUnderlineContainer);
    // 描边样式
    _this.strokeStyle = new StrokeStyle();
    _this.lineId = id;
    _this.initCoordinate(textDirection);
    return _this;
  }
  /**
     * 卸载时清除当前缓存的 textUnderlineContainer
     */
  _inherits(TextUnderlineContainer, _Container);
  return _createClass(TextUnderlineContainer, [{
    key: "dispose",
    value: function dispose() {
      _superPropGet$2(TextUnderlineContainer, "dispose", this, 3)([]);
      if (this === TextUnderlineContainer.currentInstance) {
        TextUnderlineContainer.currentInstance = null;
      }
    }
  }, {
    key: "draw",
    value: function draw(canvas) {
      canvas.save();
      _superPropGet$2(TextUnderlineContainer, "draw", this, 3)([canvas]);
      canvas.restore();
      this.drawUnderLine(canvas);
    }
    /**
       * 根据文字方向初始化坐标原点，这样判断起来更好理解一些
       */
  }, {
    key: "initCoordinate",
    value: function initCoordinate(textDirection) {
      switch (textDirection) {
        case TextDirectionType.ROTATE_90:
        case TextDirectionType.VERTICAL:
        case TextDirectionType.WORD_ART_VERTICAL_RTL:
        case TextDirectionType.WORD_ART_VERTICAL_LTR:
          this.coordinate = CoordinateZero.RIGHT_TOP;
          break;
        case TextDirectionType.ROTATE_270:
          this.coordinate = CoordinateZero.LEFT_BOTTOM;
          break;
        default:
          this.coordinate = CoordinateZero.LEFT_TOP;
      }
    }
  }, {
    key: "drawUnderLine",
    value: function drawUnderLine(canvas) {
      var _this2 = this;
      var _this$getUnderlinePos = this.getUnderlinePositionAndWidth(),
        underlinePosition = _this$getUnderlinePos.underlinePosition,
        underlineWidth = _this$getUnderlinePos.underlineWidth;
      // worldTransform 是个 getter，这里把 worldTransform 缓存起来，避免多次计算
      var worldTransform = this.worldTransform;
      this.children.forEach(function (textNode) {
        canvas.save();
        canvas.beginPath();
        // 添加线条默认样式
        _this2.strokeStyle.applyTo(canvas);
        canvas.nativeStrokeStyle = textNode.decorationLineColor;
        canvas.lineWidth = underlineWidth;
        var _this2$getTextNodeUnd = _this2.getTextNodeUnderlinePoint(underlinePosition, textNode, worldTransform),
          start = _this2$getTextNodeUnd.start,
          end = _this2$getTextNodeUnd.end;
        canvas.moveTo(start.x, start.y);
        canvas.lineTo(end.x, end.y);
        canvas.stroke();
        canvas.restore();
      });
    }
    /**
       * 计算当前行的下划线位置和粗细
       * 这个位置可能是 x 方向也可能是 y 方向，取决于当前 container 的文字方向
       * @returns
       */
  }, {
    key: "getUnderlinePositionAndWidth",
    value: function getUnderlinePositionAndWidth() {
      var _this3 = this;
      var worldTransform = this.worldTransform;
      var underlinePosition = null;
      var underlineWidth = 0;
      this.children.forEach(function (textNode) {
        // 这里用 start 或 end 都行，因为这里计算的下划线位置是垂直于下划线方向的，这个方向上 start end 的值是一样的
        // 把 start 点转换为相对于当前 container 坐标系的点
        var textNodeUnderlinePoint = worldTransform.applyInverse(textNode.underlinePoint.start);
        var textNodeUnderlineWidth = textNode.decorationLineWidth;
        underlinePosition = _this3.processUnderlinePosition(underlinePosition, textNodeUnderlinePoint);
        underlineWidth = _this3.processUnderlineWidth(underlineWidth, textNodeUnderlineWidth);
      });
      return {
        underlinePosition: underlinePosition,
        underlineWidth: underlineWidth
      };
    }
    /**
       * 比较每一个文本节点的下划线位置和当前的下划线位置
       * 根据坐标原点方向，计算出更合理的下划线位置
       * @param underlinePosition
       * @param textNodeUnderlinePoint
       * @returns
       */
  }, {
    key: "processUnderlinePosition",
    value: function processUnderlinePosition(underlinePosition, textNodeUnderlinePoint) {
      switch (this.coordinate) {
        case CoordinateZero.LEFT_BOTTOM:
          {
            return underlinePosition !== null ? Math.max(underlinePosition, textNodeUnderlinePoint.x) : textNodeUnderlinePoint.x;
          }
        case CoordinateZero.RIGHT_TOP:
          {
            return underlinePosition !== null ? Math.min(underlinePosition, textNodeUnderlinePoint.x) : textNodeUnderlinePoint.x;
          }
        case CoordinateZero.LEFT_TOP:
        default:
          {
            return underlinePosition !== null ? Math.max(underlinePosition, textNodeUnderlinePoint.y) : textNodeUnderlinePoint.y;
          }
      }
    }
    // 下划线取所有文本中最大宽度作为粗细
  }, {
    key: "processUnderlineWidth",
    value: function processUnderlineWidth(underlineWidth, textNodeUnderlineWidth) {
      return Math.max(underlineWidth, textNodeUnderlineWidth);
    }
    /**
       * 根据计算好的下划线位置修改每个 textNode 的下划线起点和终点
       * @param underlinePosition
       * @param textNode
       * @returns
       */
  }, {
    key: "getTextNodeUnderlinePoint",
    value: function getTextNodeUnderlinePoint(underlinePosition, textNode, worldTransform) {
      var _textNode$underlinePo = textNode.underlinePoint,
        start = _textNode$underlinePo.start,
        end = _textNode$underlinePo.end;
      // 把 start end 点转换为相对于当前 container 坐标系的点再进行比较
      var startOfContainer = worldTransform.applyInverse(start);
      var endOfContainer = worldTransform.applyInverse(end);
      switch (this.coordinate) {
        case CoordinateZero.LEFT_BOTTOM:
          {
            return {
              start: {
                x: underlinePosition,
                y: startOfContainer.y
              },
              end: {
                x: underlinePosition,
                y: endOfContainer.y
              }
            };
          }
        case CoordinateZero.RIGHT_TOP:
          {
            return {
              start: {
                x: underlinePosition,
                y: startOfContainer.y
              },
              end: {
                x: underlinePosition,
                y: endOfContainer.y
              }
            };
          }
        case CoordinateZero.LEFT_TOP:
        default:
          {
            return {
              start: {
                x: startOfContainer.x,
                y: underlinePosition
              },
              end: {
                x: endOfContainer.x,
                y: underlinePosition
              }
            };
          }
      }
    }
  }], [{
    key: "getInstance",
    value: function getInstance(lineId, textDirection, container) {
      var _a, _b;
      // 同一个 container 中的同一行带下划线的文字只会创建一个容器
      if (lineId !== ((_a = this.currentInstance) === null || _a === void 0 ? void 0 : _a.lineId) || container !== ((_b = this.currentInstance) === null || _b === void 0 ? void 0 : _b.parent)) {
        var instance = new TextUnderlineContainer(lineId, textDirection);
        container.addChild(instance);
        this.currentInstance = instance;
        return instance;
      }
      return this.currentInstance;
    }
  }]);
}(Container);
TextUnderlineContainer.currentInstance = null;

function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

function _arrayLikeToArray$1(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}

function _unsupportedIterableToArray$1(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray$1(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$1(r, a) : void 0;
  }
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray$1(r, e) || _nonIterableRest();
}

function convertColor(color) {
  var _a, _b;
  var lowercaseColor = color === null || color === void 0 ? void 0 : color.toLowerCase();
  if (lowercaseColor === 'transparent') {
    return Color.Transparent;
  }
  if (lowercaseColor === null || lowercaseColor === void 0 ? void 0 : lowercaseColor.startsWith('#')) {
    return convertHexColor(lowercaseColor);
  }
  if (lowercaseColor === null || lowercaseColor === void 0 ? void 0 : lowercaseColor.startsWith('rgba(')) {
    var colorContent = (_a = lowercaseColor.match(/rgba\((.*)\)/)) === null || _a === void 0 ? void 0 : _a[1];
    if (colorContent) {
      var _colorContent$split$m = colorContent.split(',').map(function (d) {
          return Number(d);
        }),
        _colorContent$split$m2 = _slicedToArray(_colorContent$split$m, 4),
        r = _colorContent$split$m2[0],
        g = _colorContent$split$m2[1],
        b = _colorContent$split$m2[2],
        a = _colorContent$split$m2[3];
      return Color.fromRGBA(r, g, b, a);
    }
  }
  if (lowercaseColor === null || lowercaseColor === void 0 ? void 0 : lowercaseColor.startsWith('rgb(')) {
    var _colorContent = (_b = lowercaseColor.match(/rgb\((.*)\)/)) === null || _b === void 0 ? void 0 : _b[1];
    if (_colorContent) {
      var _colorContent$split$m3 = _colorContent.split(',').map(function (d) {
          return Number(d);
        }),
        _colorContent$split$m4 = _slicedToArray(_colorContent$split$m3, 3),
        _r = _colorContent$split$m4[0],
        _g = _colorContent$split$m4[1],
        _b2 = _colorContent$split$m4[2];
      return Color.fromRGB(_r, _g, _b2);
    }
  }
  return Color.Black;
}
function convertHexColor(color) {
  var colorContent = color.slice(1);
  var length = colorContent.length;
  if (length === 6) {
    return Color.fromHex(color);
  }
  if (length === 8) {
    return Color.fromHex8(color);
  }
  if (length === 3) {
    var _colorContent2 = _slicedToArray(colorContent, 3),
      r = _colorContent2[0],
      g = _colorContent2[1],
      b = _colorContent2[2];
    var colorString = "#".concat(r).concat(r).concat(g).concat(g).concat(b).concat(b);
    return Color.fromHex(colorString);
  }
  if (length === 4) {
    var _colorContent3 = _slicedToArray(colorContent, 4),
      _r2 = _colorContent3[0],
      _g2 = _colorContent3[1],
      _b3 = _colorContent3[2],
      a = _colorContent3[3];
    var _colorString = "#".concat(_r2).concat(_r2).concat(_g2).concat(_g2).concat(_b3).concat(_b3).concat(a).concat(a);
    return Color.fromHex8(_colorString);
  }
  return Color.Black;
}

function rectToPath(width, height) {
  return "M 0 0 L ".concat(width, " 0 L ").concat(width, " ").concat(height, " L 0 ").concat(height, " Z");
}
function createRectNode(rectOption, id) {
  var x = rectOption.x,
    y = rectOption.y,
    width = rectOption.width,
    height = rectOption.height,
    color = rectOption.color;
  if (width === 0 || height === 0) {
    return null;
  }
  var path = rectToPath(width, height);
  var svgGraphics = new SvgGraphics(path);
  var finalColor = convertColor(color);
  var colorFill = new ColorFill(finalColor);
  svgGraphics.fill = colorFill;
  // 通过添加描边解决绘制背景之间有间隙的问题
  // 只有颜色不是半透明时才添加描边，因为半透明的颜色添加描边之后会导致形状一圈颜色变深，肉眼可以看出
  if (colorFill.color.alpha === 255) {
    svgGraphics.stroke = colorFill;
    svgGraphics.strokeWidth = 1;
  }
  svgGraphics.x = x;
  svgGraphics.y = y;
  if (id) {
    svgGraphics.id = id;
  }
  return svgGraphics;
}

function createImageNode(option, textImgId) {
  var x = option.x,
    y = option.y,
    width = option.width,
    height = option.height,
    src = option.src,
    opacity = option.opacity,
    rotate = option.rotate,
    rotateOrigin = option.rotateOrigin;
  // 避免 NaN 导致 parse svg 的时候死循环
  if (Number.isNaN(width) || Number.isNaN(height)) {
    return null;
  }
  var path = "M 0 0 L ".concat(width, " 0 L ").concat(width, " ").concat(height, " L 0 ").concat(height, " Z");
  var svgGraphics = new SvgGraphics(path);
  svgGraphics.x = x;
  svgGraphics.y = y;
  svgGraphics.id = textImgId || '';
  if (typeof opacity === 'number') {
    svgGraphics.alpha = opacity;
  }
  if (rotate && rotateOrigin) {
    // 这里逻辑有点绕
    svgGraphics.x = svgGraphics.x + rotateOrigin.x;
    svgGraphics.y = svgGraphics.y + rotateOrigin.y;
    svgGraphics.pivotX = rotateOrigin.x;
    svgGraphics.pivotY = rotateOrigin.y;
    svgGraphics.angle = rotate;
  }
  var image = imageCache.get({
    alloyParams: {
      urlOrImage: src
    }
  });
  svgGraphics.fill = new ImageFill(image);
  return svgGraphics;
}

/**
 * 是否是 iOS 平台
 * @param {user agent} ua
 */
function isIOS() {
  var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return /(iphone|ipad|ipod)/i.test(ua);
}
/**
 * 是否是 iPad
 * @param {user agent} ua
 */
function isPad() {
  return isAndroidPad() || isIPad();
}
/**
 * 是否是 Android Pad
 * @param {user agent} ua
 */
function isAndroidPad() {
  var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  var innerUA = ua;
  if (typeof innerUA === 'undefined') {
    innerUA = window.navigator.userAgent;
  }
  var containsAndroid = /(android)/i.test(innerUA);
  var containsMobile = /mobile/i.test(innerUA);
  return containsAndroid && !containsMobile;
}
/**
 * 是否是 iPad
 * @param {user agent} ua
 */
function isIPad() {
  var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return /(ipad)/i.test(ua);
}
/**
 * 获取ios系统版本
 */
function getIOSVersion() {
  var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  var reg = new RegExp('CPU( iPhone)? OS ([0-9]+_{1}[0-9]+(_{1}[0-9]+)*) like', 'i');
  var result = reg.exec(ua);
  if (!(result === null || result === void 0 ? void 0 : result[2])) return 0;
  var _result = _slicedToArray(result, 3),
    version = _result[2];
  return versionToNum(version.replace(/_/g, '.'));
}
function versionToNum(version) {
  var numbers = version.split('.');
  var sum = 0;
  if (numbers.length >= 1) {
    sum = parseInt(numbers[0], 10) * 10000;
    if (numbers.length >= 2) {
      sum += parseInt(numbers[1], 10) * 100;
      if (numbers.length >= 3) {
        sum += parseInt(numbers[2], 10);
      }
    }
  }
  return sum;
}

/**
 * 过滤掉 ios15 中导致页面崩溃的字体
 * @param fontFamily
 * @returns
 */
function filterOutIos15CrashFontFamily(fontFamily) {
  try {
    if (isIOS()) {
      var iosVersion = getIOSVersion();
      // ios 15.0 在 canvas 绘制中文时使用了 '-apple-system' 字体会导致页面崩溃。https://github.com/antvis/G2/issues/3635
      // system-ui 字体也有这个问题
      if (iosVersion && iosVersion >= 150000 && iosVersion < 151000) {
        return fontFamily.split(',').filter(function (d) {
          return !d.includes('apple-system') && !d.includes('system-ui');
        }).join(',');
      }
    }
    return fontFamily;
  } catch (err) {
    return fontFamily;
  }
}

function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

var isVerticalDirection = function isVerticalDirection(textDirection) {
  return textDirection === TextDirectionType.VERTICAL || textDirection === TextDirectionType.ROTATE_90 || textDirection === TextDirectionType.WORD_ART_VERTICAL_RTL || textDirection === TextDirectionType.WORD_ART_VERTICAL_LTR || textDirection === TextDirectionType.ROTATE_270;
};
var verticalTypeToTextDirectionMap = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, VerticalType.Vertical, TextDirectionType.VERTICAL), VerticalType.Vertical90, TextDirectionType.ROTATE_90), VerticalType.Vertical270, TextDirectionType.ROTATE_270), VerticalType.WordArtVerticalLtr, TextDirectionType.WORD_ART_VERTICAL_LTR), VerticalType.WordArtVerticalRtl, TextDirectionType.WORD_ART_VERTICAL_RTL);
function verticalTypeToTextDirection(verticalType) {
  if (!verticalType) {
    return TextDirectionType.HORIZONTAL;
  }
  return verticalTypeToTextDirectionMap[verticalType];
}

function renderTextEffect(renderTextOption, extraOption) {
  var textNode = renderTextOption.textNode,
    textBgNode = renderTextOption.textBgNode,
    logicOffsetXOfLine = renderTextOption.logicOffsetXOfLine,
    logicOffsetYOfLine = renderTextOption.logicOffsetYOfLine,
    textElement = renderTextOption.textElement,
    logicWidth = renderTextOption.logicWidth,
    logicLineWidth = renderTextOption.logicLineWidth,
    logicLineHeight = renderTextOption.logicLineHeight,
    logicHeight = renderTextOption.logicHeight,
    getLineBaselinePosition = renderTextOption.getLineBaselinePosition,
    bgLogicHeight = renderTextOption.bgLogicHeight,
    bgLogicOffsetYOfLine = renderTextOption.bgLogicOffsetYOfLine;
  var textDirection = extraOption.textDirection,
    filterDisplayOptions = extraOption.filterDisplayOptions,
    forbidFilter = extraOption.forbidFilter,
    forbidWebgl = extraOption.forbidWebgl,
    _extraOption$effectSc = extraOption.effectScale,
    effectScale = _extraOption$effectSc === void 0 ? 1 : _extraOption$effectSc;
  if (!logicWidth || !textNode) {
    return;
  }
  var effect = textElement === null || textElement === void 0 ? void 0 : textElement.effect;
  if (!effect) {
    return;
  }
  var fontSize = ((textElement === null || textElement === void 0 ? void 0 : textElement.fontSize) || 0) * effectScale;
  var isVertical = isVerticalDirection(textDirection);
  var needRotate = isVertical && !textNode.transform.rotation;
  var config = {
    characterOffset: {
      offsetStart: logicOffsetXOfLine,
      offsetSize: logicWidth,
      offsetEnd: logicLineWidth - logicOffsetXOfLine - logicWidth
    },
    fontSize: fontSize,
    height: logicHeight,
    lineHeight: logicLineHeight,
    getLineBaselinePosition: getLineBaselinePosition,
    needRotate: needRotate,
    isVertical: isVertical,
    offsetToLineBottom: logicLineHeight - logicHeight - logicOffsetYOfLine
  };
  var filters = [];
  if (!forbidFilter) {
    filters = generateEffectFilters(effect, {
      forbidWebgl: forbidWebgl,
      filterDisplayOptions: filterDisplayOptions,
      isPicture: false,
      textConfig: config
    });
  }
  textNode.filters = filters;
  if (textBgNode) {
    var textReflectionFilterIndex = filters.findIndex(function (filter) {
      return filter.type === 'reflection';
    });
    // 背景的 reflection 和文字的 reflection 可能不一样
    if (textReflectionFilterIndex !== -1 && (bgLogicHeight !== logicHeight || bgLogicOffsetYOfLine !== logicOffsetYOfLine)) {
      var _generateEffectFilter = generateEffectFilters({
          reflection: effect === null || effect === void 0 ? void 0 : effect.reflection
        }, {
          forbidWebgl: forbidWebgl,
          filterDisplayOptions: filterDisplayOptions,
          isPicture: false,
          textConfig: Object.assign(Object.assign({}, config), {
            height: bgLogicHeight,
            offsetToLineBottom: logicLineHeight - bgLogicHeight - bgLogicOffsetYOfLine
          })
        }),
        _generateEffectFilter2 = _slicedToArray(_generateEffectFilter, 1),
        bgReflectionFilter = _generateEffectFilter2[0];
      // 替换掉文字映像 filter
      filters.splice(textReflectionFilterIndex, 1, bgReflectionFilter);
    }
    textBgNode.filters = filters;
  }
}

function renderTextFill(renderTextOption, extraOption) {
  var textNode = renderTextOption.textNode,
    logicOffsetXOfLine = renderTextOption.logicOffsetXOfLine,
    logicOffsetYOfLine = renderTextOption.logicOffsetYOfLine,
    textElement = renderTextOption.textElement,
    logicLineWidth = renderTextOption.logicLineWidth,
    logicLineHeight = renderTextOption.logicLineHeight,
    logicWidth = renderTextOption.logicWidth,
    logicHeight = renderTextOption.logicHeight;
  var _extraOption$shouldSh = extraOption.shouldShowTextFill,
    shouldShowTextFill = _extraOption$shouldSh === void 0 ? true : _extraOption$shouldSh;
  if (!(textElement === null || textElement === void 0 ? void 0 : textElement.fill) || !shouldShowTextFill || !textNode) {
    return;
  }
  var isVertical = isVerticalDirection(extraOption.textDirection);
  var frame = {
    width: logicLineWidth,
    height: logicLineHeight,
    flipH: false,
    flipV: false,
    rotate: 0,
    left: 0,
    top: 0
  };
  var needRotate = isVertical && !textNode.transform.rotation;
  var config = {
    fillMode: FillMode.NORMAL,
    frame: frame,
    scaleX: 1,
    scaleY: 1,
    textConfig: {
      offsetX: -logicOffsetXOfLine,
      offsetY: -logicOffsetYOfLine,
      rectXOffset: textNode.rectXOffset,
      rectYOffset: textNode.rectYOffset,
      textWidth: logicWidth,
      textHeight: logicHeight,
      needRotate: needRotate
    }
  };
  setFillStyle(textNode, textElement.fill, config);
}

function renderTextStroke(renderTextOption, extraOption) {
  var textNode = renderTextOption.textNode,
    textElement = renderTextOption.textElement,
    logicLineWidth = renderTextOption.logicLineWidth,
    logicLineHeight = renderTextOption.logicLineHeight,
    logicOffsetXOfLine = renderTextOption.logicOffsetXOfLine,
    logicOffsetYOfLine = renderTextOption.logicOffsetYOfLine,
    logicWidth = renderTextOption.logicWidth,
    logicHeight = renderTextOption.logicHeight;
  if (!textNode) {
    return;
  }
  if (!(textElement === null || textElement === void 0 ? void 0 : textElement.stroke)) {
    textNode.strokeWidth = 0;
    textNode.stroke = Fill.None;
    return;
  }
  var isVertical = isVerticalDirection(extraOption.textDirection);
  var stroke = new Stroke(Object.assign(Object.assign({}, textElement.stroke), {
    textConfig: {
      offsetX: -logicOffsetXOfLine,
      offsetY: -logicOffsetYOfLine,
      rectXOffset: textNode.rectXOffset,
      rectYOffset: textNode.rectYOffset,
      textWidth: logicWidth,
      textHeight: logicHeight,
      needRotate: isVertical && !textNode.transform.rotation
    }
  }), {}, {
    width: logicLineWidth,
    height: logicLineHeight,
    flipH: false,
    flipV: false,
    rotate: 0,
    left: 0,
    top: 0
  });
  textNode.strokeWidth = stroke.strokeWidth;
  textNode.stroke = stroke.strokeFill;
  textNode.strokeLineCap = stroke.lineCap;
  textNode.strokeLineJoin = stroke.lineJoin;
  textNode.strokeDash = stroke.lineDash;
}

var DisplayRule;
(function (DisplayRule) {
  /** 不显示效果 */
  DisplayRule[DisplayRule["None"] = 0] = "None";
  /** 文本显示效果 */
  DisplayRule[DisplayRule["Text"] = 1] = "Text";
  /** 形状显示效果 */
  DisplayRule[DisplayRule["Shape"] = 2] = "Shape";
  /** 两者都显示效果 */
  DisplayRule[DisplayRule["Both"] = 3] = "Both";
})(DisplayRule || (DisplayRule = {}));
function createTextNode(text, option, textDirection, createRectText, isDeleteLineNotRotate) {
  var x = option.x,
    y = option.y,
    width = option.width,
    height = option.height,
    fontSize = option.fontSize,
    italic = option.italic,
    boxX = option.boxX,
    boxY = option.boxY,
    fontFamily = option.fontFamily,
    fontWeight = option.fontWeight,
    strike = option.strike,
    rotate = option.rotate,
    rotateOrigin = option.rotateOrigin,
    opacity = option.opacity,
    color = option.color,
    underline = option.underline,
    drawLineOffsetX = option.drawLineOffsetX;
  var rectTextOption = {
    textX: x,
    textY: y,
    rectX: boxX,
    rectY: boxY,
    rectWidth: width,
    drawLineOffsetX: drawLineOffsetX,
    isDeleteLineNotRotate: isDeleteLineNotRotate,
    rectHeight: height,
    rotate: rotate,
    rotateOrigin: rotateOrigin,
    textDirection: textDirection,
    underline: underline,
    lineThrough: strike
  };
  var textNode = createRectText(text, rectTextOption);
  if (typeof opacity === 'number') {
    textNode.alpha = opacity;
  }
  textNode.x = x;
  textNode.y = y;
  textNode.fontSize = fontSize;
  textNode.fontWeight = fontWeight;
  textNode.fontFamily = filterOutIos15CrashFontFamily(fontFamily);
  if (italic) {
    textNode.fontStyle = FontStyle.Italic;
  }
  if (rotate && rotateOrigin) {
    // 这里逻辑有点绕
    textNode.x = textNode.x + rotateOrigin.x;
    textNode.y = textNode.y + rotateOrigin.y;
    textNode.pivotX = rotateOrigin.x;
    textNode.pivotY = rotateOrigin.y;
    textNode.angle = rotate;
  }
  textNode.fill = new ColorFill(convertColor(color));
  return textNode;
}
function renderText(editorOption, extraOption) {
  // 文字效果自定义渲染逻辑
  renderTextEffect(editorOption, extraOption);
  // 文字填充自定义渲染逻辑
  renderTextFill(editorOption, extraOption);
  // 文字边框自定义渲染逻辑
  renderTextStroke(editorOption, extraOption);
}

function _callSuper$1(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1 = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet$1(t, e, o, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), e, o); return 2 & r && "function" == typeof p ? function (t) { return p.apply(o, t); } : p; }
/**
* 继承自 PointText，可以自己设置文字的宽高，避免重复测量
*/
var RectText = /*#__PURE__*/function (_Text) {
  function RectText(text, option) {
    var _this;
    _classCallCheck(this, RectText);
    _this = _callSuper$1(this, RectText, [text]);
    _this.rectUnderline = false;
    _this.rectLineThrough = false;
    _this.textDirection = TextDirectionType.HORIZONTAL;
    _this.lineThroughStyle = new StrokeStyle();
    _this.id = option.id || '';
    var underline = option.underline,
      lineThrough = option.lineThrough,
      textDirection = option.textDirection,
      drawLineOffsetX = option.drawLineOffsetX,
      isDeleteLineNotRotate = option.isDeleteLineNotRotate;
    _this.textDirection = textDirection;
    // 软回车不渲染下划线和删除线
    _this.rectUnderline = underline && text !== '\n';
    _this.rectLineThrough = lineThrough && text !== '\n';
    _this.drawLineOffsetX = drawLineOffsetX || 0;
    _this.isDeleteLineNotRotate = !!isDeleteLineNotRotate;
    _this.initRectInfo(option);
    return _this;
  }
  /**
   * 计算文字装饰线宽度
   * 这个 fontsize/15 的逻辑效仿 melo
   */
  _inherits(RectText, _Text);
  return _createClass(RectText, [{
    key: "decorationLineWidth",
    get: function get() {
      return Math.round(this.fontSize / 15);
    }
  }, {
    key: "decorationLineColor",
    get: function get() {
      if (this.fill instanceof ColorFill) {
        return this.fill.color.rgba;
      }
      return 'rgb(0, 0, 0)';
    }
  }, {
    key: "hasUnderline",
    get: function get() {
      return !!this.rectUnderline;
    }
    /**
     * 重写 render 方法，在 render 完成之后更新下划线位置
     * 由于渲染层有缓存机制，触发缓存的话就不会调用 draw 方法，所以需要在 render 中更新下划线位置
     */
  }, {
    key: "render",
    value: function render() {
      for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
        params[_key] = arguments[_key];
      }
      _superPropGet$1(RectText, "render", this, 3)(params);
      this.updateUnderlinePoint();
    }
  }, {
    key: "generateRawRenderData",
    value: function generateRawRenderData(canvas) {
      this.updateUnderlinePoint();
      var superData = _superPropGet$1(RectText, "generateRawRenderData", this, 3)([canvas]);
      if (!this.rectLineThrough) return superData;
      var _this$worldTransform = this.worldTransform,
        a = _this$worldTransform.a,
        b = _this$worldTransform.b,
        c = _this$worldTransform.c,
        d = _this$worldTransform.d,
        tx = _this$worldTransform.tx,
        ty = _this$worldTransform.ty;
      var _this$getRawRenderDat = this.getRawRenderData(),
        movePoint = _this$getRawRenderDat.movePoint,
        linePoint = _this$getRawRenderDat.linePoint;
      return Object.assign(Object.assign({}, superData), {
        lineThrough: {
          transform: {
            a: a,
            b: b,
            c: c,
            d: d,
            tx: tx,
            ty: ty
          },
          lineWidth: this.lineThroughStyle.width,
          lineCap: this.lineThroughStyle.lineCap,
          lineJoin: this.lineThroughStyle.lineJoin,
          lineDash: this.lineThroughStyle.dash,
          lineDashOffset: this.lineThroughStyle.dashOffset,
          miterLimit: this.lineThroughStyle.miterLimit,
          decorationLineWidth: this.decorationLineWidth,
          decorationLineColor: this.decorationLineColor,
          movePoint: movePoint,
          linePoint: linePoint
        }
      });
    }
  }, {
    key: "updateInitialBounds",
    value: function updateInitialBounds(initialBounds) {
      var rectXOffset = this.rectXOffset,
        rectYOffset = this.rectYOffset,
        rectWidth = this.rectWidth,
        rectHeight = this.rectHeight;
      initialBounds.clear().addFrame(rectXOffset, rectYOffset, rectWidth + rectXOffset, rectHeight + rectYOffset);
    }
    /**
     * 绘制文本删除线
     * @param canvas
     * @returns
     */
  }, {
    key: "drawLineThrough",
    value: function drawLineThrough(canvas) {
      if (!this.rectLineThrough) {
        return;
      }
      canvas.save();
      // 添加线条默认样式
      this.lineThroughStyle.applyTo(canvas);
      canvas.nativeStrokeStyle = this.decorationLineColor;
      canvas.lineWidth = this.decorationLineWidth;
      var _this$getRawRenderDat2 = this.getRawRenderData(),
        movePoint = _this$getRawRenderDat2.movePoint,
        linePoint = _this$getRawRenderDat2.linePoint;
      canvas.beginPath();
      canvas.moveTo(movePoint.x, movePoint.y);
      canvas.lineTo(linePoint.x, linePoint.y);
      canvas.stroke();
      canvas.restore();
    }
  }, {
    key: "getRawRenderData",
    value: function getRawRenderData() {
      var _this$initialBounds = this.initialBounds,
        width = _this$initialBounds.width,
        height = _this$initialBounds.height,
        minY = _this$initialBounds.minY,
        maxY = _this$initialBounds.maxY;
      var movePoint;
      var linePoint;
      if (this.isLineThroughNeedRotate()) {
        /**
        * 这里加上 rectXOffset 主要是为了解决中文标点符号的删除线位置不太对的问题
        * 为了对标 office 和 dom 的中文标点符号的排版逻辑，文字的实际位置和绘制区域相差比较大
        * 加上 rectXOffset 之后，删除线 x 方向基本就是从绘制区域的 x 位置开始了，删除线位置就正常了
        */
        var x = width / 2 + this.rectXOffset;
        movePoint = {
          x: x,
          y: minY
        };
        linePoint = {
          x: x,
          y: maxY
        };
      } else {
        // x 加上 rectXOffset 是为了让绘制起始位置放在文字节点起始位置
        movePoint = {
          x: this.rectXOffset + this.drawLineOffsetX,
          y: -(height / 4)
        };
        linePoint = {
          x: width + this.rectXOffset,
          y: -(height / 4)
        };
      }
      return {
        movePoint: movePoint,
        linePoint: linePoint
      };
    }
    /**
     * 这里只计算出下划线点的位置，交由外面的 underlineContainer 来绘制，是为了保证同一行文字的下划线对齐
     * @returns
     */
  }, {
    key: "updateUnderlinePoint",
    value: function updateUnderlinePoint() {
      if (!this.rectUnderline) {
        this.underlinePoint = {
          start: this.worldTransform.apply(new Point(0, 0)),
          end: this.worldTransform.apply(new Point(0, 0))
        };
        return;
      }
      var _this$initialBounds2 = this.initialBounds,
        width = _this$initialBounds2.width,
        height = _this$initialBounds2.height,
        minY = _this$initialBounds2.minY,
        maxY = _this$initialBounds2.maxY;
      var startPoint;
      var endPoint;
      if (this.isUnderLineNeedRotate()) {
        // 竖排的中文下划线需要在文字左侧边界，长度为文字高度
        startPoint = new Point(0, minY);
        endPoint = new Point(0, maxY);
      } else {
        // 其他的文字下划线就在当前文字底部边界（跟随文字旋转），长度为文字宽度
        // height / 8 这个位置是个经验值，是效仿 melo 的实现
        startPoint = new Point(0, height / 8);
        endPoint = new Point(width - this.drawLineOffsetX, height / 8);
      }
      // underlinePoint 给外界使用，所以需要转为世界坐标系
      this.underlinePoint = {
        start: this.worldTransform.apply(startPoint),
        end: this.worldTransform.apply(endPoint)
      };
    }
    /**
     * 文本删除线是否需要旋转
     * 这个规则是和本地对齐
     */
  }, {
    key: "isLineThroughNeedRotate",
    value: function isLineThroughNeedRotate() {
      if ((this.textDirection === TextDirectionType.WORD_ART_VERTICAL_LTR || this.textDirection === TextDirectionType.WORD_ART_VERTICAL_RTL) && !this.isDeleteLineNotRotate) {
        // 本地 ppt 中堆积文字删除线都是水平的，所以如果文字有旋转，删除线也跟着旋转，保证删除线水平
        return !!this.transform.rotation;
      }
      return this.textDirection === TextDirectionType.VERTICAL && !this.transform.rotation;
    }
    /**
     * 文本下划线是否需要旋转
     * 这个规则是和本地对齐
     */
  }, {
    key: "isUnderLineNeedRotate",
    value: function isUnderLineNeedRotate() {
      return isVerticalDirection(this.textDirection) && !this.transform.rotation;
    }
  }, {
    key: "initRectInfo",
    value: function initRectInfo(option) {
      var textX = option.textX,
        textY = option.textY,
        rectX = option.rectX,
        rectY = option.rectY,
        rectWidth = option.rectWidth,
        rectHeight = option.rectHeight,
        rotate = option.rotate,
        rotateOrigin = option.rotateOrigin;
      if (rotate && rotateOrigin) {
        // 如果有旋转，就要计算出旋转前的文字区域
        var originWidth = rectHeight;
        var originHeight = rectWidth;
        // rect 当前左上角
        var rectStartPosition = {
          x: rectX,
          y: rectY
        };
        var rectRotateOrigin = {
          x: rotateOrigin.x + rectX,
          y: rotateOrigin.y + rectY
        };
        // rect 左上角旋转前的位置
        var originRectPosition = counterclockwiseRotate(rotate, rectStartPosition, rectRotateOrigin);
        var textStartPosition = {
          x: textX,
          y: textY
        };
        var textRotateOrigin = {
          x: rotateOrigin.x + textX,
          y: rotateOrigin.y + textY
        };
        // text 左上角旋转前的位置
        var originTextPosition = counterclockwiseRotate(rotate, textStartPosition, textRotateOrigin);
        // 我也不太清楚为什么这么算，只是这样算确实没问题
        if (rotate === 90) {
          this.rectXOffset = originRectPosition.y - originTextPosition.y;
          this.rectYOffset = originTextPosition.x - originRectPosition.x;
        } else if (rotate === 270) {
          this.rectXOffset = originTextPosition.y - originRectPosition.y;
          this.rectYOffset = originRectPosition.x - originTextPosition.x;
        }
        this.rectWidth = originWidth;
        this.rectHeight = originHeight;
      } else {
        this.rectXOffset = rectX - textX;
        this.rectYOffset = rectY - textY;
        this.rectWidth = rectWidth;
        this.rectHeight = rectHeight;
      }
    }
  }]);
}(Text);
/**
* 计算给定位置的点 startPosition 绕 rotatePosition 逆时针旋转 angle 之后点的位置
* @param angle
* @param startPosition
* @param rotatePosition
* @returns
*/
function counterclockwiseRotate(angle, startPosition, rotatePosition) {
  var radian = angle * Math.PI / 180;
  var x = startPosition.x,
    y = startPosition.y;
  var originX = rotatePosition.x,
    originY = rotatePosition.y;
  var targetX = (x - originX) * Math.cos(radian) - (y - originY) * Math.sin(radian) + originX;
  var targetY = (x - originX) * Math.sin(radian) + (y - originY) * Math.cos(radian) + originY;
  return {
    x: targetX,
    y: targetY
  };
}

var DrawContext = /*#__PURE__*/function () {
  function DrawContext(_ref) {
    var _this = this;
    var addChildAt = _ref.addChildAt,
      removeChild = _ref.removeChild,
      getTextDirection = _ref.getTextDirection,
      isNotFillInvisibleText = _ref.isNotFillInvisibleText,
      getTextRect = _ref.getTextRect,
      needCustomRender = _ref.needCustomRender,
      getCustomNode = _ref.getCustomNode,
      rectTextId = _ref.rectTextId,
      textImgId = _ref.textImgId;
    _classCallCheck(this, DrawContext);
    // 判断文本是否不在canvas内部
    this.isInvisible = function (option) {
      var _a;
      var textRect = (_a = _this.getTextRect) === null || _a === void 0 ? void 0 : _a.call(_this);
      if (textRect && option) {
        if (option.y + option.height < 0 || option.y > textRect.height) {
          return true;
        }
      }
      return false;
    };
    this.addChildAt = addChildAt;
    this.removeChild = removeChild;
    this.getTextDirection = getTextDirection;
    this.isNotFillInvisibleText = isNotFillInvisibleText;
    this.getTextRect = getTextRect;
    this.needCustomRender = needCustomRender;
    this.getCustomNode = getCustomNode;
    this.rectTextId = rectTextId;
    this.textImgId = textImgId;
  }
  return _createClass(DrawContext, [{
    key: "createContainer",
    value: function createContainer(zIndex, option) {
      var container = new Container();
      this.addChildAt(container, zIndex, option === null || option === void 0 ? void 0 : option.type);
      return container;
    }
  }, {
    key: "removeContainer",
    value: function removeContainer(container) {
      this.removeChild(container);
    }
  }, {
    key: "fillText",
    value: function fillText(container, text, option) {
      var _this2 = this;
      var _a;
      if (this.isNotFillInvisibleText && this.isInvisible(option)) {
        return null;
      }
      var textElement = option.textElement;
      var textNode;
      if (((_a = this.needCustomRender) === null || _a === void 0 ? void 0 : _a.call(this, textElement)) && this.getCustomNode) {
        // 渲染为自定义文本
        textNode = this.getCustomNode(text, option, container);
      } else {
        textNode = createTextNode(text, option, this.getTextDirection(), function (text, option) {
          return new RectText(text, Object.assign(Object.assign({}, option), {
            id: _this2.rectTextId
          }));
        });
        // 普通文本目前不需要监听事件，为了优化渲染性能，就设置 pointerEvents 为 none
        textNode.pointerEvents = PointerEvents.NONE;
      }
      if (textNode.hasUnderline) {
        // 文本有下划线的话，渲染在下划线容器中
        var textUnderlineContainer = TextUnderlineContainer.getInstance(option.lineId, this.getTextDirection(), container);
        textUnderlineContainer === null || textUnderlineContainer === void 0 ? void 0 : textUnderlineContainer.addChild(textNode);
      } else {
        container.addChild(textNode);
      }
      return textNode;
    }
  }, {
    key: "drawImage",
    value: function drawImage(container, option) {
      var imageNode = createImageNode(option, this.textImgId);
      if (!imageNode) {
        return null;
      }
      container.addChild(imageNode);
      return imageNode;
    }
  }, {
    key: "fillRect",
    value: function fillRect(container, option) {
      var rectNode = createRectNode(option);
      if (!rectNode) {
        return null;
      }
      container.addChild(rectNode);
      return rectNode;
    }
  }, {
    key: "clearRect",
    value: function clearRect(container) {
      var _disposeContainer = function disposeContainer(container) {
        var length = container.children.length;
        // 从后往前删，才能在一次遍历中删除所有 child
        for (var i = length - 1; i >= 0; i--) {
          var child = container.children[i];
          if (child instanceof Container) {
            _disposeContainer(child);
          }
          child === null || child === void 0 ? void 0 : child.dispose();
          container.removeChild(child);
        }
      };
      _disposeContainer(container);
    }
  }]);
}();

var renderUtils = {
  getTextColor: function getTextColor(textNode) {
    var _a, _b;
    if ((textNode === null || textNode === void 0 ? void 0 : textNode.fill) instanceof ColorFill) {
      return (_b = (_a = textNode === null || textNode === void 0 ? void 0 : textNode.fill) === null || _a === void 0 ? void 0 : _a.color) === null || _b === void 0 ? void 0 : _b.rgba;
    }
    return null;
  }
};

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var ImagePromiseCollector = /*#__PURE__*/function () {
  function ImagePromiseCollector() {
    _classCallCheck(this, ImagePromiseCollector);
  }
  return _createClass(ImagePromiseCollector, [{
    key: "start",
    value:
    /**
     * 开始收集，标记当前已有的 image promise
     */
    function start() {
      this.keysBeforeCollect = new Set(imageCache.requestListInfo.requestMap.keys());
    }
    /**
     * 结束收集，计算出 start 到 stop 之间新增的 image promise
     * @returns
     */
  }, {
    key: "stop",
    value: function stop() {
      var imagePromiseArr = [];
      var _iterator = _createForOfIteratorHelper(imageCache.requestListInfo.requestMap),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
            key = _step$value[0],
            value = _step$value[1];
          if (!this.keysBeforeCollect.has(key)) {
            imagePromiseArr.push(value);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return imagePromiseArr;
    }
  }]);
}();

// touch 触发 mouse 事件的最大间隔，如果 touch 事件触发到 mouse 事件触发的时间间隔小于这个值，则认为这次 mouse 事件是 touch 行为触发的
var TOUCH_END_TO_MOUSE_EVENT_MAX_INTERVAL = 300;
var MouseEventSourceDetector = /*#__PURE__*/_createClass(function MouseEventSourceDetector() {
  var _this = this;
  _classCallCheck(this, MouseEventSourceDetector);
  this.touchendTime = 0;
  /**
     * 判断 mouse 事件是否由 touch 行为触发
     */
  this.isTriggerByTouch = function (event) {
    var _a;
    var nativeEvent = 'nativeEvent' in event ? event.nativeEvent : event;
    // 如果支持 sourceCapabilities 属性，可以根据这个判断
    if ((_a = nativeEvent.sourceCapabilities) === null || _a === void 0 ? void 0 : _a.firesTouchEvents) {
      return true;
    }
    // 鼠标触发的 mousedown 事件 buttons 不可能为 0
    if (nativeEvent.type === 'mousedown') {
      return nativeEvent.buttons === 0;
    }
    // mouseup 事件的 buttons 也可能是 0，所以只能通过是否触发了 touchend 来判断
    return nativeEvent.timeStamp - _this.touchendTime < TOUCH_END_TO_MOUSE_EVENT_MAX_INTERVAL;
  };
  /**
     * 判断 mouse 事件是否由鼠标行为触发
     */
  this.isTriggerByMouse = function (event) {
    return !_this.isTriggerByTouch(event);
  };
  this.initEvent = function () {
    window.addEventListener('touchend', _this.handleTouchEnd, true);
  };
  this.handleTouchEnd = function (event) {
    // 记录 touchend 触发的时间戳
    _this.touchendTime = event.timeStamp;
  };
  this.initEvent();
});
var mouseEventSourceDetector = new MouseEventSourceDetector();

function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, e, o, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), e, o); return 2 & r && "function" == typeof p ? function (t) { return p.apply(o, t); } : p; }
var MOUSE_RIGHT_BUTTON = 2;
var DEFAULT_TEXT_CURSOR = 'text';
var DocsEditor = /*#__PURE__*/function (_Container) {
  function DocsEditor(textEditorProps, isLazyLoadEditor) {
    var _this;
    _classCallCheck(this, DocsEditor);
    var _a, _b;
    _this = _callSuper(this, DocsEditor);
    _this.imgPromiseArr = [];
    _this.imagePromiseCollector = new ImagePromiseCollector();
    // 标记当前 textEditor 是否触发了 mousedown，主要是在 mousemove 的时候做判断
    _this.isTouchStart = false;
    // 用于比对元素位置大小是否有变化
    _this.lastMatrix = new Matrix();
    _this.resetValue = function (editorValue, needUpdateRect) {
      var _a;
      if (!_this.editor) {
        _this.initEditor();
      }
      var rect = needUpdateRect ? _this.textRect : undefined;
      (_a = _this.editor) === null || _a === void 0 ? void 0 : _a.resetValue(editorValue, rect);
    };
    _this.changeRect = function () {
      var _a;
      _this.updateEmptyRegionIfExist();
      if (!_this.editor) {
        _this.initEditor();
      }
      (_a = _this.editor) === null || _a === void 0 ? void 0 : _a.changeRect(_this.textRect);
    };
    _this.updateProps = function (props) {
      _this.props = Object.assign(Object.assign({}, _this.props), props);
    };
    _this.changeReadonly = function (readonly) {
      if (!_this.editor) {
        _this.initEditor();
      }
      _this.editor.changeReadonly(readonly);
    };
    _this.getLayoutSize = function () {
      var _a;
      return (_a = _this.editor) === null || _a === void 0 ? void 0 : _a.getLayoutSize();
    };
    _this.updateCursor = function () {
      var cursor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_TEXT_CURSOR;
      _this.cursor = cursor;
    };
    _this.invalidateMeasureCache = function (fontFamily) {
      Editor.invalidateMeasureCache(fontFamily);
    };
    /**
       * 如果当前元素位置变化了，更新下光标位置
       * 如果命中缓存的话，可能出现当前组件没重新渲染，但是 worldTransform 变化的情况
       * 所以只在当前组件 onDidRender 更新可能是不全面的
       * 暴露这个方法是为了在外界可以更新当前正在编辑文本框的光标位置
       */
    _this.ifUpdateEditorSurface = function () {
      var _a, _b;
      // 只有当前编辑器大小或位置变化时才更新光标位置
      if (_this.isMatrixChange()) {
        if ((_a = _this.editor) === null || _a === void 0 ? void 0 : _a.isEditing) {
          (_b = _this.editor) === null || _b === void 0 ? void 0 : _b.updateSurface();
        }
        _this.lastMatrix.copyFrom(_this.worldTransform);
      }
    };
    // eslint-disable-next-line @typescript-eslint/member-ordering
    _this.updateEditorProps = _this.imageCollectDecorator(function (updateProps) {
      var _a, _b, _c;
      var value = updateProps.value,
        rect = updateProps.rect,
        readonly = updateProps.readonly;
      if (value) {
        (_a = _this.editor) === null || _a === void 0 ? void 0 : _a.resetValue(value);
      }
      if (rect) {
        (_b = _this.editor) === null || _b === void 0 ? void 0 : _b.changeRect(rect);
      }
      if (typeof readonly === 'boolean') {
        (_c = _this.editor) === null || _c === void 0 ? void 0 : _c.changeReadonly(readonly);
      }
    });
    /**
     * 获取文字容器
     * @returns
     */
    _this.getRenderSize = function () {
      return (_this.children.find(function (child) {
        return child.id === ContainerType.text;
      }) || _this).worldBounds;
    };
    /**
     * 返回一个 promise，这个 promise 会在当前文字渲染涉及到的图片资源加载完成之后 resolve
     * @returns
     */
    _this.promiseImageLoaded = function () {
      return Promise.all(_this.imgPromiseArr);
    };
    // eslint-disable-next-line @typescript-eslint/member-ordering
    _this.initEditor = _this.imageCollectDecorator(function () {
      var _a, _b, _c, _d, _e, _f, _g;
      var drawContext = _this.initDrawContext();
      _this.editor = new Editor(Object.assign(Object.assign({}, _this.props), {
        rect: _this.textRect,
        eventArea: _this.props.eventArea,
        readonly: _this.props.readonly,
        value: _this.props.value,
        drawContext: drawContext,
        getBackDeleteTextProps: _this.props.getBackDeleteTextProps,
        // backspace时先删属性
        renderUtils: renderUtils,
        // ios 禁止掉聚焦自动滚动，自己实现滚动
        preventScrollOnFocus: _this.props.preventScrollOnFocus,
        onSelectionChange: _this.props.handleSelectionChange,
        onValueChange: _this.props.onValueChange,
        onBeforeValueChange: _this.handleBeforeValueChange,
        onCompositionInput: _this.props.onCompositionInput,
        renderText: _this.renderTextExtra,
        getMatrix: function getMatrix() {
          return _this.worldTransform;
        },
        onFocus: (_a = _this.props) === null || _a === void 0 ? void 0 : _a.onFocus,
        onBlur: (_b = _this.props) === null || _b === void 0 ? void 0 : _b.onBlur,
        onKeyDown: (_c = _this.props) === null || _c === void 0 ? void 0 : _c.handleKeyDown,
        onBeforeLayout: _this.props.handleBeforeLayout,
        getContainer: _this.getContainer,
        getAppPosition: (_d = _this.props) === null || _d === void 0 ? void 0 : _d.getAppPosition,
        onBeforeInput: (_e = _this.props) === null || _e === void 0 ? void 0 : _e.handleBeforeInput
      }));
      (_g = (_f = _this.props).onInit) === null || _g === void 0 ? void 0 : _g.call(_f);
      // 移除处理空文本占位
      if (_this.emptySvgGraphics) {
        _this.emptySvgGraphics.dispose();
        _this.removeChild(_this.emptySvgGraphics);
        _this.emptySvgGraphics = null;
      }
    });
    _this.updateTextRect = function (textRect) {
      _this.textRect = textRect;
    };
    _this.getEditorValue = function () {
      var _a;
      return (_a = _this.editor) === null || _a === void 0 ? void 0 : _a.getValue();
    };
    _this.resetValueWithoutEffect = function (editorValue) {
      var _a;
      (_a = _this.editor) === null || _a === void 0 ? void 0 : _a.resetValueWithoutEffect(editorValue);
    };
    _this.getSelectionProps = function () {
      var _a;
      return (_a = _this.editor) === null || _a === void 0 ? void 0 : _a.getSelectionProps();
    };
    /**
     * 获取当前画布所在的容器 dom
     * @returns
     */
    _this.getContainer = function () {
      var _a, _b, _c, _d;
      var app = (_b = (_a = _this.props) === null || _a === void 0 ? void 0 : _a.getApplication) === null || _b === void 0 ? void 0 : _b.call(_a);
      if (!app) {
        return null;
      }
      return (_d = (_c = app === null || app === void 0 ? void 0 : app.view) === null || _c === void 0 ? void 0 : _c["native"]) === null || _d === void 0 ? void 0 : _d.parentElement;
    };
    _this.getDefaultTextDirection = function () {
      var _a;
      var _ref = ((_a = _this.editor) === null || _a === void 0 ? void 0 : _a.getValue(false)) || _this.props.value,
        vertical = _ref.vertical;
      return verticalTypeToTextDirection(vertical);
    };
    /**
       * 根据 zIndex 添加子元素
       * 渲染层不支持设置 zIndex，使用这个接口实现类似功能
       * zIndex 可以设置大于 children.length，但是 addChildAt 不支持设置大于 children.length 的 index
       * 不过按照 addChildAt 的逻辑，如果 zIndex > children.length，直接设置为 children.length 就可以了
       * @param child
       * @param zIndex
       */
    _this.addChildWithIndex = function (child, zIndex, type) {
      if (type) {
        child.id = type;
      }
      _this.addChildAt(child, Math.min(zIndex, _this.children.length));
    };
    _this.renderTextExtra = function (option) {
      var _this$props$needRende = _this.props.needRenderTextExtra,
        needRenderTextExtra = _this$props$needRende === void 0 ? true : _this$props$needRende;
      if (!needRenderTextExtra) {
        return;
      }
      var getRenderTextExtraOption = _this.props.getRenderTextExtraOption || function () {
        return {
          forbidWebgl: false
        };
      };
      renderText(option, getRenderTextExtraOption(option));
    };
    /**
     * editor 数据变更前回调
     */
    _this.handleBeforeValueChange = function () {
      var _a, _b;
      (_b = (_a = _this.props).onBeforeValueChange) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    _this.handleTouchStart = function (e) {
      var _a;
      if (_this.isEditing) {
        // 不阻止默认事件的话，移动端长按会失焦
        e.preventDefault();
      }
      if (!_this.editor) {
        _this.initEditor();
      }
      _this.autoRegisterEvent();
      if (_this.isEditing) {
        _this.isTouchStart = true;
        (_a = _this.editor) === null || _a === void 0 ? void 0 : _a.triggerTouchStart({
          posXOfWorld: e.worldX,
          posYOfWorld: e.worldY
        });
      }
    };
    _this.handleTouchMove = function (e) {
      var _a, _b, _c;
      if (_this.isEditing) {
        // 根据当前鼠标位置和画布的位置计算出当前鼠标相对于画布的位置
        var _ref2 = ((_b = (_a = _this.props).getAppPosition) === null || _b === void 0 ? void 0 : _b.call(_a)) || {
            x: 0,
            y: 0
          },
          x = _ref2.x,
          y = _ref2.y;
        // 需要考虑到页面滚动的距离
        var _document$documentEle = document.documentElement,
          _document$documentEle2 = _document$documentEle.scrollTop,
          scrollTop = _document$documentEle2 === void 0 ? 0 : _document$documentEle2,
          _document$documentEle3 = _document$documentEle.scrollLeft,
          scrollLeft = _document$documentEle3 === void 0 ? 0 : _document$documentEle3;
        (_c = _this.editor) === null || _c === void 0 ? void 0 : _c.triggerTouchMove({
          posXOfWorld: _this.getTouchOrMouseInfo(e).pageX - (x + scrollLeft),
          posYOfWorld: _this.getTouchOrMouseInfo(e).pageY - (y + scrollTop)
        });
      }
    };
    /**
     * 加载动态注册的事件
     */
    _this.autoRegisterEvent = function () {
      if (isPad()) {
        // ipad 客户端需要兼容鼠标，但是操作逻辑仍然是和触摸一样的逻辑
        document.addEventListener('mousemove', _this.handleTouchMove, true);
        document.addEventListener('mouseup', _this.handleTouchEnd, true);
      } else {
        // mousemove 需要监听全局，否则超出文本范围后鼠标拖拽选区无反应
        // useCapture 参数为 true 是为了避免有的元素阻止冒泡之后就不会触发 document 上的对应事件
        document.addEventListener('mousemove', _this.handleMouseMove, true);
        // 超出文本框之后触发 mouseup 也要执行 handleMouseUp
        document.addEventListener('mouseup', _this.handleMouseUp, true);
      }
      document.addEventListener('touchmove', _this.handleTouchMove, true);
      document.addEventListener('touchend', _this.handleTouchEnd, true);
      document.addEventListener('touchcancel', _this.handleTouchEnd, true);
      document.addEventListener('contextmenu', _this.handleContextMenu, true);
    };
    _this.handleMouseUp = function () {
      var _a;
      _this.isMouseDown = false;
      (_a = _this.editor) === null || _a === void 0 ? void 0 : _a.triggerMouseUp();
      _this.autoUnRegisterEvent();
    };
    _this.handleContextMenu = function () {
      var _a, _b;
      if (_this.isEditing) {
        if ((_a = _this.editor) === null || _a === void 0 ? void 0 : _a.readonly) return; // 只读态，直接返回
        if (!_this.editor) {
          _this === null || _this === void 0 ? void 0 : _this.initEditor();
        }
        (_b = _this.editor) === null || _b === void 0 ? void 0 : _b.focus();
      }
    };
    _this.handleTouchEnd = function (e) {
      var _a, _b, _c, _d;
      if (_this.isTouchStart && _this.isEditing && !((_a = _this.editor) === null || _a === void 0 ? void 0 : _a.readonly)) {
        var _ref3 = ((_c = (_b = _this.props).getAppPosition) === null || _c === void 0 ? void 0 : _c.call(_b)) || {
            x: 0,
            y: 0
          },
          x = _ref3.x,
          y = _ref3.y;
        var _document$documentEle4 = document.documentElement,
          _document$documentEle5 = _document$documentEle4.scrollTop,
          scrollTop = _document$documentEle5 === void 0 ? 0 : _document$documentEle5,
          _document$documentEle6 = _document$documentEle4.scrollLeft,
          scrollLeft = _document$documentEle6 === void 0 ? 0 : _document$documentEle6;
        (_d = _this.editor) === null || _d === void 0 ? void 0 : _d.triggerTouchEnd({
          posXOfWorld: _this.getTouchOrMouseInfo(e).pageX - (x + scrollLeft),
          posYOfWorld: _this.getTouchOrMouseInfo(e).pageY - (y + scrollTop)
        });
      }
      _this.isTouchStart = false;
      _this.autoUnRegisterEvent();
    };
    _this.handleMouseMove = function (e) {
      var _a, _b, _c;
      if (_this.isMouseDown) {
        var _ref4 = ((_b = (_a = _this.props).getAppPosition) === null || _b === void 0 ? void 0 : _b.call(_a)) || {
            x: 0,
            y: 0
          },
          x = _ref4.x,
          y = _ref4.y;
        (_c = _this.editor) === null || _c === void 0 ? void 0 : _c.triggerMouseMove({
          posXOfWorld: e.pageX - x,
          posYOfWorld: e.pageY - y
        });
      }
    };
    _this.getTouchOrMouseInfo = function (event) {
      if (_this.isTouchEvent(event)) {
        return event.changedTouches[0];
      }
      return event;
    };
    _this.isTouchEvent = function (event) {
      return 'changedTouches' in event;
    };
    /**
     * 取消动态注册的事件
     */
    _this.autoUnRegisterEvent = function () {
      if (isPad()) {
        document.removeEventListener('mousemove', _this.handleTouchMove, true);
        document.removeEventListener('mouseup', _this.handleTouchEnd, true);
      } else {
        document.removeEventListener('mousemove', _this.handleMouseMove, true);
        document.removeEventListener('mouseup', _this.handleMouseUp, true);
      }
      document.removeEventListener('touchmove', _this.handleTouchMove, true);
      document.removeEventListener('touchend', _this.handleTouchEnd, true);
      document.removeEventListener('touchcancel', _this.handleTouchEnd, true);
      document.removeEventListener('contextmenu', _this.handleContextMenu, true);
    };
    _this.registerEvent = function () {
      var _a;
      if ((_a = _this.editor) === null || _a === void 0 ? void 0 : _a.readonly) return;
      if (Editor.platform !== Platform.pc) {
        _this.touchStartOff = _this.onTouchStart(_this.handleTouchStart || function () {});
        if (isPad()) {
          // 需要兼容鼠标，但是操作逻辑仍然是和触摸一样的逻辑
          _this.mouseDownOff = _this.onMouseDown(_this.handleIpadMousedown);
        }
      } else {
        /**
         * 移动端不注册 mousedown 事件，有两个原因
         * 1. 移动端不需要 mousedown 事件
         * 2. 移动端偶现会触发 mousedown，导致进入编辑态，不符合预期
         */
        _this.mouseDownOff = _this.onMouseDown(_this.handleMouseDown || function () {});
      }
    };
    _this.handleIpadMousedown = function (event) {
      if (mouseEventSourceDetector.isTriggerByTouch(event)) {
        return;
      }
      _this.handleTouchStart(event);
    };
    _this.handleMouseDown = function (e) {
      var _a;
      _this.isMouseDown = true;
      e.preventDefault();
      if (!_this.editor) {
        _this.initEditor();
      }
      _this.autoRegisterEvent();
      // 右键不触发trigger
      var event = e.nativeEvent;
      if (!((event === null || event === void 0 ? void 0 : event.button) === MOUSE_RIGHT_BUTTON && _this.isExpanded())) {
        (_a = _this.editor) === null || _a === void 0 ? void 0 : _a.triggerMouseDown({
          posXOfWorld: e.worldX,
          posYOfWorld: e.worldY
        }, event);
      }
    };
    _this.id = textEditorProps.id || '';
    _this.props = textEditorProps;
    var _textEditorProps$defa = textEditorProps.defaultFontFamily,
      defaultFontFamily = _textEditorProps$defa === void 0 ? [] : _textEditorProps$defa,
      _textEditorProps$spec = textEditorProps.specificFontFamilies,
      specificFontFamilies = _textEditorProps$spec === void 0 ? {} : _textEditorProps$spec,
      _textEditorProps$plat = textEditorProps.platform,
      platform = _textEditorProps$plat === void 0 ? Platform.pc : _textEditorProps$plat,
      _textEditorProps$supp = textEditorProps.supportMouseOnTouchScreen,
      supportMouseOnTouchScreen = _textEditorProps$supp === void 0 ? false : _textEditorProps$supp;
    Editor.setDefaultFontFamily(defaultFontFamily, specificFontFamilies);
    Editor.setPlatform(platform);
    Editor.setSupportMouseOnTouchScreen(supportMouseOnTouchScreen);
    _this.textRect = _this.props.rect;
    (_b = (_a = _this.props).resetShouldUpdate) === null || _b === void 0 ? void 0 : _b.call(_a); // 加载后重置状态
    if (!isLazyLoadEditor) {
      _this.initEditor();
    } else if (_this.props.eventArea === EventArea.all) {
      // 只有事件响应为整个编辑器且没有初始化 editor 时才需要创建空形状用于接收事件
      _this.initEmptyRegion();
    }
    if (!_this.props.noDefaultEvent) {
      _this.registerEvent();
    }
    _this.updateCursor(_this.props.cursor);
    return _this;
  }
  /** #TODO: check */
  _inherits(DocsEditor, _Container);
  return _createClass(DocsEditor, [{
    key: "forceRender",
    value: function forceRender() {
      var _a;
      (_a = this.editor) === null || _a === void 0 ? void 0 : _a.forceRender();
    }
  }, {
    key: "dispose",
    value: function dispose() {
      var _a, _b, _c;
      _superPropGet(DocsEditor, "dispose", this, 3)([]);
      this.unregisterEvent();
      (_b = (_a = this.props).onDispose) === null || _b === void 0 ? void 0 : _b.call(_a);
      (_c = this.editor) === null || _c === void 0 ? void 0 : _c.detach();
    }
  }, {
    key: "onDidRender",
    value: function onDidRender() {
      _superPropGet(DocsEditor, "onDidRender", this, 3)([]);
      this.ifUpdateEditorSurface();
    }
  }, {
    key: "initDrawContext",
    value: function initDrawContext() {
      var _this2 = this;
      return new DrawContext({
        addChildAt: this.addChildWithIndex,
        removeChild: function removeChild(child) {
          // remove 之前需要手动调用子节点的 dispose
          child === null || child === void 0 ? void 0 : child.dispose();
          _this2.removeChild(child);
        },
        getTextDirection: this.props.getTextDirection || this.getDefaultTextDirection,
        isNotFillInvisibleText: this.props.isNotFillInvisibleText || false,
        getTextRect: function getTextRect() {
          return _this2.textRect;
        },
        needCustomRender: this.props.needCustomRender,
        getCustomNode: this.props.getCustomNode,
        rectTextId: this.props.rectTextId,
        textImgId: this.props.textImgId
      });
    }
    /**
     * 方法装饰器，收集函数执行中新增的 imagePromise
     * @param fn
     * @returns
     */
  }, {
    key: "imageCollectDecorator",
    value: function imageCollectDecorator(fn) {
      var _this3 = this;
      return function () {
        _this3.imagePromiseCollector.start();
        for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
          params[_key] = arguments[_key];
        }
        var result = fn.apply(_this3, params);
        _this3.imgPromiseArr = _this3.imagePromiseCollector.stop();
        return result;
      };
    }
  }, {
    key: "updateEmptyRegionIfExist",
    value: function updateEmptyRegionIfExist() {
      if (this.emptySvgGraphics) {
        var _this$textRect = this.textRect,
          x = _this$textRect.x,
          y = _this$textRect.y,
          width = _this$textRect.width,
          height = _this$textRect.height;
        this.emptySvgGraphics.path = "M 0 0 L ".concat(width, " 0 L ").concat(width, " ").concat(height, " L 0 ").concat(height, " Z");
        this.emptySvgGraphics.x = x;
        this.emptySvgGraphics.y = y;
      }
    }
    /**
     * 创建一块空白区域，用来接收点击事件
     */
  }, {
    key: "initEmptyRegion",
    value: function initEmptyRegion() {
      var _this$props$rect = this.props.rect,
        x = _this$props$rect.x,
        y = _this$props$rect.y,
        width = _this$props$rect.width,
        height = _this$props$rect.height;
      var svgPath = "M 0 0 L ".concat(width, " 0 L ").concat(width, " ").concat(height, " L 0 ").concat(height, " Z");
      var svgGraphics = new SvgGraphics(svgPath);
      svgGraphics.x = x;
      svgGraphics.y = y;
      svgGraphics.fill = new ColorFill(Color.Transparent);
      this.emptySvgGraphics = svgGraphics;
      this.addChild(svgGraphics);
    }
  }, {
    key: "isMatrixChange",
    value: function isMatrixChange() {
      var _this$lastMatrix = this.lastMatrix,
        a = _this$lastMatrix.a,
        b = _this$lastMatrix.b,
        c = _this$lastMatrix.c,
        d = _this$lastMatrix.d,
        tx = _this$lastMatrix.tx,
        ty = _this$lastMatrix.ty;
      var _this$worldTransform = this.worldTransform,
        currentA = _this$worldTransform.a,
        currentB = _this$worldTransform.b,
        currentC = _this$worldTransform.c,
        currentD = _this$worldTransform.d,
        currentTx = _this$worldTransform.tx,
        currentTy = _this$worldTransform.ty;
      return a !== currentA || b !== currentB || c !== currentC || d !== currentD || tx !== currentTx || ty !== currentTy;
    }
  }, {
    key: "isEditing",
    get: function get() {
      var _a;
      return (_a = this.editor) === null || _a === void 0 ? void 0 : _a.isEditing;
    }
  }, {
    key: "isExpanded",
    value: function isExpanded() {
      var _a, _b;
      return ((_b = (_a = this.editor) === null || _a === void 0 ? void 0 : _a.isSelectionExpanded) === null || _b === void 0 ? void 0 : _b.call(_a)) || false;
    }
  }, {
    key: "unregisterEvent",
    value: function unregisterEvent() {
      var _a, _b, _c;
      (_a = this.mouseDownOff) === null || _a === void 0 ? void 0 : _a.dispose();
      (_b = this.clickOff) === null || _b === void 0 ? void 0 : _b.dispose();
      (_c = this.touchStartOff) === null || _c === void 0 ? void 0 : _c.dispose();
    }
  }]);
}(Container);

export { RectText, DocsEditor as default };
